import axios from "axios";

/**
 * Requests user's orders
 * @param {string} sewperContactSeq
 * @returns {Promise<AxiosResponse<OrdersListItem[]>>}
 */
export function getOrders(sewperContactSeq) {
  return axios(`/sewppublic/orderapp/order/search/SCS/${sewperContactSeq}`);
}

/**
 * Requests order details for a given orderId
 * @param {number} orderId
 * @returns {Promise<AxiosResponse<OrderDetails>>}
 */
export function getOrderDetails(orderId) {
  return axios.get(`/sewppublic/orderapp/order/orderdetails/${orderId}`);
}

/**
 *
 * @returns {Promise<axios.AxiosResponse<OrdersUser>>}
 */
export function getOrderUser() {
  return axios.get("/sewppublic/orderapp/order/user");
}
